export default __webpack_public_path__ + "static/media/homeScene_3.07f83ab7.png";